import { apiConfig } from '../apiConfig';
import { addCommonHeaders, handleResponse, handleErrors } from '../apiUtils';

export default {
    index: async (missionId, handleRedirect = null) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/requirement_groups";

        try {
            const response = await fetch(url, {
                method: "GET",
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },


    new: async (missionId, handleRedirect = null) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/requirement_groups/new";

        try {
            const response = await fetch(url, {
                method: "GET",
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },


    destroy: async (missionId, requirementGroupId, handleRedirect = null) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/requirement_groups/" + requirementGroupId;

        try {
            const response = await fetch(url, {
                method: "DELETE",
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

    update: async ({ missionId, requirementGroupId, maxSessions, name, handleRedirect = null }) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/requirement_groups/" + requirementGroupId;

        const body = JSON.stringify({
            requirement_group: {
                name: name,
                max_spots: maxSessions
            }
        });

        try {
            const response = await fetch(url, {
                method: "PATCH",
                body: body,
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },


    create: async ({ missionId, maxSessions, name, handleRedirect = null }) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/requirement_groups/";

        const body = JSON.stringify({
            requirement_group: {
                name: name,
                max_spots: maxSessions
            }
        });

        try {
            const response = await fetch(url, {
                method: "POST",
                body: body,
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },


    // create: async ({ missionId, selectedRequirementType, selectedCategoryType, selectedComparison, selectedValue, handleRedirect = null }) => {
    //     const url = apiConfig.apiUrl + "missions/" + missionId + "/requirements";

    //     const body = JSON.stringify({
    //         requirement: {
    //             mission_id: missionId,
    //             requirement_type: selectedRequirementType,
    //             category_type: selectedCategoryType,
    //             comparison: selectedComparison,
    //             value: selectedValue
    //         }
    //     });

    //     try {
    //         const response = await fetch(url, {
    //             method: "POST",
    //             body: body,
    //             headers: addCommonHeaders(),
    //             credentials: 'include',
    //         })

    //         return await handleResponse(response, handleRedirect);

    //     } catch (error) {
    //         return handleErrors(error);
    //     }
    // },

}